import api from '@/services/api'

const getEpisodeMarkers = (id) => {
  return api.get(`/episodes/${id}/markers`).then(async ({data}) => {
    return data
  })
}

export default {
  getEpisodeMarkers
}
